import { DocnboardChatPanel, DocnboardChatPanelAI } from './components';

export function registerAIComponents() {
  customElements.define('docnboard-chat-panel', DocnboardChatPanel);
  customElements.define('docnboard-chat-panel-ai', DocnboardChatPanelAI);
}
